import { UnmatchedUpload } from '__generated__/atlas-types'

import { UPLOAD_COLOR_MAX_AMOUNT } from 'features/Linesheets/Modals/ManageImagesModal/manageImagesModal.constants'
import { useGetDropzoneState } from 'features/Linesheets/Modals/ManageImagesModal/manageImagesModal.hooks'
import { StyleColor } from 'features/Linesheets/Modals/ManageImagesModal/manageImagesModal.types'
import useStore from 'features/Linesheets/Modals/ManageImagesModal/store/useManageImagesStore'

export const useStyleColorProps = (color: StyleColor) => {
  const selectedImages = useStore((state) => state.selectedImages)
  const isRemovingImages = useStore((state) => state.isRemovingImages)
  const isSavingImages = useStore((state) => state.isSavingImages)
  const isUploadingImages = useStore((state) => state.isUploadingImages)
  const styleColors = useStore((state) => state.styleColors)
  const setStyleColors = useStore((state) => state.setStyleColors)
  const setHasStyleColorChanges = useStore(
    (state) => state.setHasStyleColorChanges,
  )
  const setSelectedImages = useStore((state) => state.setSelectedImages)

  const areActionsDisabled =
    isRemovingImages || isSavingImages || isUploadingImages

  const canAssignImage =
    !color.imageUrl && selectedImages.size && selectedImages.size === 1

  const canUploadImage = !color.imageUrl && !selectedImages.size

  const assignColorImage = (image: UnmatchedUpload | null) => {
    setHasStyleColorChanges({ hasStyleColorChanges: true })

    const index = styleColors.findIndex(
      (styleColor) => styleColor.id === color.id,
    )
    if (index < 0) {
      return
    }

    const newStyleColors = [...styleColors]
    newStyleColors[index] = {
      ...newStyleColors[index],
      imageId: image ? (image.id as string) : null,
      imageUrl: image ? (image.url as string) : null,
      unmatchedUploadId: image ? (image.unmatchedUploadId as string) : null,
    }

    setStyleColors({ styleColors: newStyleColors })
  }

  const { getInputProps, getRootProps } = useGetDropzoneState(
    (img) => assignColorImage(img),
    UPLOAD_COLOR_MAX_AMOUNT,
    !canUploadImage || areActionsDisabled,
  )

  const handleAssignImage = () => {
    if (!canAssignImage || areActionsDisabled) {
      return
    }

    assignColorImage(Array.from(selectedImages.values())[0])
    setSelectedImages({ selectedImages: new Map() })
  }

  const handleInputEvent = (e: React.DragEvent | React.MouseEvent): void => {
    if (areActionsDisabled) {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  const handleRemoveImage = () => {
    if (!areActionsDisabled) {
      assignColorImage(null)
    }
  }

  return {
    areActionsDisabled,
    canAssignImage,
    canUploadImage,
    getInputProps,
    getRootProps,
    handleAssignImage,
    handleInputEvent,
    handleRemoveImage,
  }
}
